import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ValUInquireService } from './valU-inquire.service';
import {PAYMENTATTEMPT_STATUS} from 'src/app/shared/paymentStatuses'

@Component({
  selector: 'app-val-u-success-failure',
  templateUrl: './val-u-success-failure.component.html',
  styleUrls: ['./val-u-success-failure.component.scss']
})
export class ValUSuccessFailureComponent implements OnInit {

  constructor(
    private route  :ActivatedRoute ,
    private router : Router,
    private inquireTransaction :ValUInquireService
  ) { }
  cartId : string
  result : any
  showPleaseWait: boolean = true;
  paymentPaid: boolean = true;
  showRecipt:boolean = false;
  reason: string = "";
  orderId : string = "";

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe(async params => {
      this.cartId = params.get("pattern");
    });
    if(!this.cartId){
      this.router.navigate(['/'])
    }
    console.log(this.cartId)
    this.inquireTransaction.setParams({
      cartId : this.cartId
    })
    this.result = await this.inquireTransaction.make();
    console.log(this.result)

    if(this.result.status === PAYMENTATTEMPT_STATUS.PAID ){
      this.showPleaseWait = false
      this.paymentPaid = true;
      this.orderId = this.result.transactionRefNUm
      const vpihs = JSON.parse(localStorage.getItem("vpihs"))
      this.showRecipt = !!vpihs;
    }else{
      this.showPleaseWait = false
      this.paymentPaid = false;
      this.showRecipt = false
      if (this.result.msg) this.reason = this.result.msg;
    }
  }

  onContinueClick() {
    const url = localStorage.getItem('customerRedirectUrl');
    if (url) {
      const customerRedirectUrl = new URL(url);
      customerRedirectUrl.searchParams.set('status', this.result.status);
      customerRedirectUrl.searchParams.set(
        'providerRefNum',
        this.result.orderId,
      );
      customerRedirectUrl.searchParams.set('customerReference', this.result.customerReference);
      window.location.href = customerRedirectUrl.toString();
      return;
    }
    this.router.navigate(['/']);
  }
}
